import {SuggestAction} from '@yandex-delivery/api/model/suggest'
import {useFormContext} from '@yandex-delivery/form'

import {fetchAddressSuggest} from '../../api'
import {AddressSuggestResponse} from '../../types'
import {fromPinDropToPointAddress} from '../../utils'
import {EntranceInputProps} from './EntranceInput.types'

export function useGeomagnetSuggest({
  locationName,
  logName,
  fullName,
  shortName,
}: EntranceInputProps['names']) {
  const {watch, setFieldValue} = useFormContext()
  const type = locationName.includes('destinationPoints') ? 'b' : 'a'

  async function setEntranceCoordinates(value?: string): Promise<void> {
    if (value) {
      const location = await fetchAddressSuggest({
        type: type,
        location: watch(locationName),
        action: SuggestAction.GEO_MAGNET,
        entrance: value,
        log: watch(logName),
      })
        .then(res => res as unknown as AddressSuggestResponse)
        .then(fromPinDropToPointAddress)

      if (location) {
        // геомагнет съест любой подъезд и не выкинет ошибки, если такого подъезда не существует
        // поэтому тут доверяем клиенту и ставим тот подъезд, который он ввел
        // По дефолту возвращаются координаты центра здания, если подъезд не размечен или введен некорректно
        setFieldValue(locationName, location.coordinates)
        setFieldValue(shortName, location.shortName)
        setFieldValue(fullName, location.fullName)
      }
    }
  }
  return {
    setEntranceCoordinates,
  }
}
